const ct = "active", ut = "autocomplete", ft = "batch", dt = "chart", ht = "checkbox", lt = "chips", mt = "color", $t = "country", pt = "currency", Mt = "datatable", Dt = "datatable/simple", yt = "datetime", Tt = "date", gt = "email", Yt = "file", Et = "filter", _t = "hidden", St = "image", Ot = "multiple", wt = "number", vt = "password", Lt = "radio", At = "reader", Pt = "select", xt = "skeleton", bt = "terms and conditions", Ct = "textarea", Nt = "text", Ht = "time", It = "external action", jt = "sidebar screen", xe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ACTIVE_TYPE: ct,
  AUTOCOMPLETE_TYPE: ut,
  BATCH_TYPE: ft,
  CHART_TYPE: dt,
  CHECKBOX_TYPE: ht,
  CHIPS_TYPE: lt,
  COLOR_TYPE: mt,
  COUNTRY_TYPE: $t,
  CURRENCY_TYPE: pt,
  DATA_TABLE_SIMPLE_TYPE: Dt,
  DATA_TABLE_TYPE: Mt,
  DATE_TIME_TYPE: yt,
  DATE_TYPE: Tt,
  EMAIL_TYPE: gt,
  EXTERNAL_ACTION_TYPE: It,
  FILE_TYPE: Yt,
  FILTER_TYPE: Et,
  HIDDEN_TYPE: _t,
  IMAGE_TYPE: St,
  MULTIPLE_TYPE: Ot,
  NUMBER_TYPE: wt,
  PASSWORD_TYPE: vt,
  RADIO_TYPE: Lt,
  READER_TYPE: At,
  SELECT_TYPE: Pt,
  SIDEBAR_SCREEN_LAYOUT: jt,
  SKELETON_TYPE: xt,
  TERMS_AND_CONDITIONS_TYPE: bt,
  TEXT_AREA_TYPE: Ct,
  TEXT_TYPE: Nt,
  TIME_TYPE: Ht
}, Symbol.toStringTag, { value: "Module" })), be = (t = "") => t.toLowerCase().normalize("NFD").replace(new RegExp("\\p{Diacritic}", "gu"), "");
function Rt() {
  const t = Math.floor(Math.random() * 16777215).toString(16);
  return t.length === 6 ? `#${t}` : Rt();
}
var et = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function rt(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var nt = { exports: {} };
(function(t, e) {
  (function(u, h) {
    t.exports = h();
  })(et, function() {
    var u = 1e3, h = 6e4, $ = 36e5, Y = "millisecond", g = "second", _ = "minute", Z = "hour", M = "day", X = "week", v = "month", G = "quarter", U = "year", W = "date", f = "Invalid Date", m = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, D = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, y = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(o) {
      var s = ["th", "st", "nd", "rd"], r = o % 100;
      return "[" + o + (s[(r - 20) % 10] || s[r] || s[0]) + "]";
    } }, P = function(o, s, r) {
      var i = String(o);
      return !i || i.length >= s ? o : "" + Array(s + 1 - i.length).join(r) + o;
    }, H = { s: P, z: function(o) {
      var s = -o.utcOffset(), r = Math.abs(s), i = Math.floor(r / 60), n = r % 60;
      return (s <= 0 ? "+" : "-") + P(i, 2, "0") + ":" + P(n, 2, "0");
    }, m: function o(s, r) {
      if (s.date() < r.date())
        return -o(r, s);
      var i = 12 * (r.year() - s.year()) + (r.month() - s.month()), n = s.clone().add(i, v), a = r - n < 0, c = s.clone().add(i + (a ? -1 : 1), v);
      return +(-(i + (r - n) / (a ? n - c : c - n)) || 0);
    }, a: function(o) {
      return o < 0 ? Math.ceil(o) || 0 : Math.floor(o);
    }, p: function(o) {
      return { M: v, y: U, w: X, d: M, D: W, h: Z, m: _, s: g, ms: Y, Q: G }[o] || String(o || "").toLowerCase().replace(/s$/, "");
    }, u: function(o) {
      return o === void 0;
    } }, I = "en", L = {};
    L[I] = y;
    var C = "$isDayjsObject", x = function(o) {
      return o instanceof w || !(!o || !o[C]);
    }, N = function o(s, r, i) {
      var n;
      if (!s)
        return I;
      if (typeof s == "string") {
        var a = s.toLowerCase();
        L[a] && (n = a), r && (L[a] = r, n = a);
        var c = s.split("-");
        if (!n && c.length > 1)
          return o(c[0]);
      } else {
        var l = s.name;
        L[l] = s, n = l;
      }
      return !i && n && (I = n), n || !i && I;
    }, p = function(o, s) {
      if (x(o))
        return o.clone();
      var r = typeof s == "object" ? s : {};
      return r.date = o, r.args = arguments, new w(r);
    }, d = H;
    d.l = N, d.i = x, d.w = function(o, s) {
      return p(o, { locale: s.$L, utc: s.$u, x: s.$x, $offset: s.$offset });
    };
    var w = function() {
      function o(r) {
        this.$L = N(r.locale, null, !0), this.parse(r), this.$x = this.$x || r.x || {}, this[C] = !0;
      }
      var s = o.prototype;
      return s.parse = function(r) {
        this.$d = function(i) {
          var n = i.date, a = i.utc;
          if (n === null)
            return /* @__PURE__ */ new Date(NaN);
          if (d.u(n))
            return /* @__PURE__ */ new Date();
          if (n instanceof Date)
            return new Date(n);
          if (typeof n == "string" && !/Z$/i.test(n)) {
            var c = n.match(m);
            if (c) {
              var l = c[2] - 1 || 0, T = (c[7] || "0").substring(0, 3);
              return a ? new Date(Date.UTC(c[1], l, c[3] || 1, c[4] || 0, c[5] || 0, c[6] || 0, T)) : new Date(c[1], l, c[3] || 1, c[4] || 0, c[5] || 0, c[6] || 0, T);
            }
          }
          return new Date(n);
        }(r), this.init();
      }, s.init = function() {
        var r = this.$d;
        this.$y = r.getFullYear(), this.$M = r.getMonth(), this.$D = r.getDate(), this.$W = r.getDay(), this.$H = r.getHours(), this.$m = r.getMinutes(), this.$s = r.getSeconds(), this.$ms = r.getMilliseconds();
      }, s.$utils = function() {
        return d;
      }, s.isValid = function() {
        return this.$d.toString() !== f;
      }, s.isSame = function(r, i) {
        var n = p(r);
        return this.startOf(i) <= n && n <= this.endOf(i);
      }, s.isAfter = function(r, i) {
        return p(r) < this.startOf(i);
      }, s.isBefore = function(r, i) {
        return this.endOf(i) < p(r);
      }, s.$g = function(r, i, n) {
        return d.u(r) ? this[i] : this.set(n, r);
      }, s.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, s.valueOf = function() {
        return this.$d.getTime();
      }, s.startOf = function(r, i) {
        var n = this, a = !!d.u(i) || i, c = d.p(r), l = function(R, O) {
          var b = d.w(n.$u ? Date.UTC(n.$y, O, R) : new Date(n.$y, O, R), n);
          return a ? b : b.endOf(M);
        }, T = function(R, O) {
          return d.w(n.toDate()[R].apply(n.toDate("s"), (a ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(O)), n);
        }, E = this.$W, S = this.$M, A = this.$D, V = "set" + (this.$u ? "UTC" : "");
        switch (c) {
          case U:
            return a ? l(1, 0) : l(31, 11);
          case v:
            return a ? l(1, S) : l(0, S + 1);
          case X:
            var F = this.$locale().weekStart || 0, z = (E < F ? E + 7 : E) - F;
            return l(a ? A - z : A + (6 - z), S);
          case M:
          case W:
            return T(V + "Hours", 0);
          case Z:
            return T(V + "Minutes", 1);
          case _:
            return T(V + "Seconds", 2);
          case g:
            return T(V + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, s.endOf = function(r) {
        return this.startOf(r, !1);
      }, s.$set = function(r, i) {
        var n, a = d.p(r), c = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[M] = c + "Date", n[W] = c + "Date", n[v] = c + "Month", n[U] = c + "FullYear", n[Z] = c + "Hours", n[_] = c + "Minutes", n[g] = c + "Seconds", n[Y] = c + "Milliseconds", n)[a], T = a === M ? this.$D + (i - this.$W) : i;
        if (a === v || a === U) {
          var E = this.clone().set(W, 1);
          E.$d[l](T), E.init(), this.$d = E.set(W, Math.min(this.$D, E.daysInMonth())).$d;
        } else
          l && this.$d[l](T);
        return this.init(), this;
      }, s.set = function(r, i) {
        return this.clone().$set(r, i);
      }, s.get = function(r) {
        return this[d.p(r)]();
      }, s.add = function(r, i) {
        var n, a = this;
        r = Number(r);
        var c = d.p(i), l = function(S) {
          var A = p(a);
          return d.w(A.date(A.date() + Math.round(S * r)), a);
        };
        if (c === v)
          return this.set(v, this.$M + r);
        if (c === U)
          return this.set(U, this.$y + r);
        if (c === M)
          return l(1);
        if (c === X)
          return l(7);
        var T = (n = {}, n[_] = h, n[Z] = $, n[g] = u, n)[c] || 1, E = this.$d.getTime() + r * T;
        return d.w(E, this);
      }, s.subtract = function(r, i) {
        return this.add(-1 * r, i);
      }, s.format = function(r) {
        var i = this, n = this.$locale();
        if (!this.isValid())
          return n.invalidDate || f;
        var a = r || "YYYY-MM-DDTHH:mm:ssZ", c = d.z(this), l = this.$H, T = this.$m, E = this.$M, S = n.weekdays, A = n.months, V = n.meridiem, F = function(O, b, B, J) {
          return O && (O[b] || O(i, a)) || B[b].slice(0, J);
        }, z = function(O) {
          return d.s(l % 12 || 12, O, "0");
        }, R = V || function(O, b, B) {
          var J = O < 12 ? "AM" : "PM";
          return B ? J.toLowerCase() : J;
        };
        return a.replace(D, function(O, b) {
          return b || function(B) {
            switch (B) {
              case "YY":
                return String(i.$y).slice(-2);
              case "YYYY":
                return d.s(i.$y, 4, "0");
              case "M":
                return E + 1;
              case "MM":
                return d.s(E + 1, 2, "0");
              case "MMM":
                return F(n.monthsShort, E, A, 3);
              case "MMMM":
                return F(A, E);
              case "D":
                return i.$D;
              case "DD":
                return d.s(i.$D, 2, "0");
              case "d":
                return String(i.$W);
              case "dd":
                return F(n.weekdaysMin, i.$W, S, 2);
              case "ddd":
                return F(n.weekdaysShort, i.$W, S, 3);
              case "dddd":
                return S[i.$W];
              case "H":
                return String(l);
              case "HH":
                return d.s(l, 2, "0");
              case "h":
                return z(1);
              case "hh":
                return z(2);
              case "a":
                return R(l, T, !0);
              case "A":
                return R(l, T, !1);
              case "m":
                return String(T);
              case "mm":
                return d.s(T, 2, "0");
              case "s":
                return String(i.$s);
              case "ss":
                return d.s(i.$s, 2, "0");
              case "SSS":
                return d.s(i.$ms, 3, "0");
              case "Z":
                return c;
            }
            return null;
          }(O) || c.replace(":", "");
        });
      }, s.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, s.diff = function(r, i, n) {
        var a, c = this, l = d.p(i), T = p(r), E = (T.utcOffset() - this.utcOffset()) * h, S = this - T, A = function() {
          return d.m(c, T);
        };
        switch (l) {
          case U:
            a = A() / 12;
            break;
          case v:
            a = A();
            break;
          case G:
            a = A() / 3;
            break;
          case X:
            a = (S - E) / 6048e5;
            break;
          case M:
            a = (S - E) / 864e5;
            break;
          case Z:
            a = S / $;
            break;
          case _:
            a = S / h;
            break;
          case g:
            a = S / u;
            break;
          default:
            a = S;
        }
        return n ? a : d.a(a);
      }, s.daysInMonth = function() {
        return this.endOf(v).$D;
      }, s.$locale = function() {
        return L[this.$L];
      }, s.locale = function(r, i) {
        if (!r)
          return this.$L;
        var n = this.clone(), a = N(r, i, !0);
        return a && (n.$L = a), n;
      }, s.clone = function() {
        return d.w(this.$d, this);
      }, s.toDate = function() {
        return new Date(this.valueOf());
      }, s.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, s.toISOString = function() {
        return this.$d.toISOString();
      }, s.toString = function() {
        return this.$d.toUTCString();
      }, o;
    }(), j = w.prototype;
    return p.prototype = j, [["$ms", Y], ["$s", g], ["$m", _], ["$H", Z], ["$W", M], ["$M", v], ["$y", U], ["$D", W]].forEach(function(o) {
      j[o[1]] = function(s) {
        return this.$g(s, o[0], o[1]);
      };
    }), p.extend = function(o, s) {
      return o.$i || (o(s, w, p), o.$i = !0), p;
    }, p.locale = N, p.isDayjs = x, p.unix = function(o) {
      return p(1e3 * o);
    }, p.en = L[I], p.Ls = L, p.p = {}, p;
  });
})(nt);
var kt = nt.exports;
const k = /* @__PURE__ */ rt(kt);
var st = { exports: {} };
(function(t, e) {
  (function(u, h) {
    t.exports = h();
  })(et, function() {
    var u = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" }, h = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, $ = /\d\d/, Y = /\d\d?/, g = /\d*[^-_:/,()\s\d]+/, _ = {}, Z = function(f) {
      return (f = +f) + (f > 68 ? 1900 : 2e3);
    }, M = function(f) {
      return function(m) {
        this[f] = +m;
      };
    }, X = [/[+-]\d\d:?(\d\d)?|Z/, function(f) {
      (this.zone || (this.zone = {})).offset = function(m) {
        if (!m || m === "Z")
          return 0;
        var D = m.match(/([+-]|\d\d)/g), y = 60 * D[1] + (+D[2] || 0);
        return y === 0 ? 0 : D[0] === "+" ? -y : y;
      }(f);
    }], v = function(f) {
      var m = _[f];
      return m && (m.indexOf ? m : m.s.concat(m.f));
    }, G = function(f, m) {
      var D, y = _.meridiem;
      if (y) {
        for (var P = 1; P <= 24; P += 1)
          if (f.indexOf(y(P, 0, m)) > -1) {
            D = P > 12;
            break;
          }
      } else
        D = f === (m ? "pm" : "PM");
      return D;
    }, U = { A: [g, function(f) {
      this.afternoon = G(f, !1);
    }], a: [g, function(f) {
      this.afternoon = G(f, !0);
    }], S: [/\d/, function(f) {
      this.milliseconds = 100 * +f;
    }], SS: [$, function(f) {
      this.milliseconds = 10 * +f;
    }], SSS: [/\d{3}/, function(f) {
      this.milliseconds = +f;
    }], s: [Y, M("seconds")], ss: [Y, M("seconds")], m: [Y, M("minutes")], mm: [Y, M("minutes")], H: [Y, M("hours")], h: [Y, M("hours")], HH: [Y, M("hours")], hh: [Y, M("hours")], D: [Y, M("day")], DD: [$, M("day")], Do: [g, function(f) {
      var m = _.ordinal, D = f.match(/\d+/);
      if (this.day = D[0], m)
        for (var y = 1; y <= 31; y += 1)
          m(y).replace(/\[|\]/g, "") === f && (this.day = y);
    }], M: [Y, M("month")], MM: [$, M("month")], MMM: [g, function(f) {
      var m = v("months"), D = (v("monthsShort") || m.map(function(y) {
        return y.slice(0, 3);
      })).indexOf(f) + 1;
      if (D < 1)
        throw new Error();
      this.month = D % 12 || D;
    }], MMMM: [g, function(f) {
      var m = v("months").indexOf(f) + 1;
      if (m < 1)
        throw new Error();
      this.month = m % 12 || m;
    }], Y: [/[+-]?\d+/, M("year")], YY: [$, function(f) {
      this.year = Z(f);
    }], YYYY: [/\d{4}/, M("year")], Z: X, ZZ: X };
    function W(f) {
      var m, D;
      m = f, D = _ && _.formats;
      for (var y = (f = m.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(N, p, d) {
        var w = d && d.toUpperCase();
        return p || D[d] || u[d] || D[w].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(j, o, s) {
          return o || s.slice(1);
        });
      })).match(h), P = y.length, H = 0; H < P; H += 1) {
        var I = y[H], L = U[I], C = L && L[0], x = L && L[1];
        y[H] = x ? { regex: C, parser: x } : I.replace(/^\[|\]$/g, "");
      }
      return function(N) {
        for (var p = {}, d = 0, w = 0; d < P; d += 1) {
          var j = y[d];
          if (typeof j == "string")
            w += j.length;
          else {
            var o = j.regex, s = j.parser, r = N.slice(w), i = o.exec(r)[0];
            s.call(p, i), N = N.replace(i, "");
          }
        }
        return function(n) {
          var a = n.afternoon;
          if (a !== void 0) {
            var c = n.hours;
            a ? c < 12 && (n.hours += 12) : c === 12 && (n.hours = 0), delete n.afternoon;
          }
        }(p), p;
      };
    }
    return function(f, m, D) {
      D.p.customParseFormat = !0, f && f.parseTwoDigitYear && (Z = f.parseTwoDigitYear);
      var y = m.prototype, P = y.parse;
      y.parse = function(H) {
        var I = H.date, L = H.utc, C = H.args;
        this.$u = L;
        var x = C[1];
        if (typeof x == "string") {
          var N = C[2] === !0, p = C[3] === !0, d = N || p, w = C[2];
          p && (w = C[2]), _ = this.$locale(), !N && w && (_ = D.Ls[w]), this.$d = function(r, i, n) {
            try {
              if (["x", "X"].indexOf(i) > -1)
                return new Date((i === "X" ? 1e3 : 1) * r);
              var a = W(i)(r), c = a.year, l = a.month, T = a.day, E = a.hours, S = a.minutes, A = a.seconds, V = a.milliseconds, F = a.zone, z = /* @__PURE__ */ new Date(), R = T || (c || l ? 1 : z.getDate()), O = c || z.getFullYear(), b = 0;
              c && !l || (b = l > 0 ? l - 1 : z.getMonth());
              var B = E || 0, J = S || 0, Q = A || 0, tt = V || 0;
              return F ? new Date(Date.UTC(O, b, R, B, J, Q, tt + 60 * F.offset * 1e3)) : n ? new Date(Date.UTC(O, b, R, B, J, Q, tt)) : new Date(O, b, R, B, J, Q, tt);
            } catch {
              return /* @__PURE__ */ new Date("");
            }
          }(I, x, L), this.init(), w && w !== !0 && (this.$L = this.locale(w).$L), d && I != this.format(x) && (this.$d = /* @__PURE__ */ new Date("")), _ = {};
        } else if (x instanceof Array)
          for (var j = x.length, o = 1; o <= j; o += 1) {
            C[1] = x[o - 1];
            var s = D.apply(this, C);
            if (s.isValid()) {
              this.$d = s.$d, this.$L = s.$L, this.init();
              break;
            }
            o === j && (this.$d = /* @__PURE__ */ new Date(""));
          }
        else
          P.call(this, H);
      };
    };
  });
})(st);
var Ut = st.exports;
const Ft = /* @__PURE__ */ rt(Ut);
k.extend(Ft);
const Zt = /undefined/i, zt = /^[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/, Bt = (t) => !t || t === "" || t.trim().length === 0, Wt = (t) => t === !0 || t === void 0, Vt = (t) => t === void 0 || typeof t == "string" && Zt.test(t), Jt = (t) => t === null, K = (t) => Object.prototype.toString.call(t) === "[object Object]", Xt = (t, e, u) => k(t, e, u, !0).isValid(), qt = (t) => !(!t || t.split("@").length != 2 || !zt.test(t)), Gt = (t) => {
  if (Array.isArray(t)) {
    if (t.length === 0)
      return !0;
    const e = t[0];
    if (K(e) && "sections" in e)
      return !0;
  }
  return !1;
}, Kt = (t) => !!(t && K(t) && typeof t == "object" && "label" in t && "value" in t), Qt = (t) => !!(t && K(t) && typeof t == "object" && "url" in t), te = (t, e) => t < e, ee = (t, e) => t <= e, re = (t, e) => t > e, ne = (t, e) => t >= e, q = {
  isDataSource: Qt,
  isDate: Xt,
  isEmail: qt,
  isEmpty: Bt,
  isGreaterThan: re,
  isGreaterThanOrEqualTo: ne,
  isLessThan: te,
  isLessThanThanOrEqualTo: ee,
  isNull: Jt,
  isObject: K,
  isSelect: Kt,
  isTab: Gt,
  isUndefined: Vt,
  isVisible: Wt
}, se = (t, e = ",") => {
  const u = new RegExp("[^0-9-" + e + "]", "g"), h = `${t}`.replace(u, "").replace(e, "."), $ = parseFloat(h);
  return isNaN($) ? 0 : $;
}, ie = (t, e = {}) => {
  const {
    locale: u = "es-CO",
    currency: h = "COP",
    digits: $ = 2
  } = e;
  return (q.isNull(t) || q.isUndefined(t)) && (t = 0), new Intl.NumberFormat(u, {
    style: "currency",
    currency: h,
    minimumFractionDigits: $
  }).format(t);
}, oe = {
  format: ie,
  unformat: se
};
function ae(t) {
  const e = k(t);
  return q.isDate(t) ? e.toDate() : null;
}
function ce(t, e = "DD/MM/YYYY") {
  let u = k();
  return t instanceof Date && (u = k(t)), u.format(e);
}
const ue = {
  format: ce,
  from: ae
};
function fe(t, e = ["YYYY-MM-DD", "HH:mm:ss"]) {
  let u = k();
  return t instanceof Date && (u = k(t)), u.format(e.join(" "));
}
const de = {
  format: fe
}, he = (t, e = 2) => t.toFixed(e), le = {
  format: he
}, me = (t, e) => e === void 0 || t < e ? t : e, $e = (t, e) => e === void 0 || t > e ? t : e, pe = (t, e) => e === void 0 ? t : t > e ? e : t, Me = (t, e) => e === void 0 ? t : t < e ? e : t, Ce = {
  minOf: me,
  maxOf: $e,
  minBy: Me,
  maxBy: pe
}, De = (t, e) => {
  if (!e || !t)
    return "";
  t = t.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
  const h = new RegExp("[\\?&]" + t + "=([^&#]*)").exec(e);
  return h === null ? "" : decodeURIComponent(h[1].replace(/\+/g, " "));
}, Ne = {
  query: De
}, ye = "label", Te = "value", ge = (t, e) => {
  const u = (e == null ? void 0 : e.label.split(".").filter(($) => $ !== "")) ?? [
    ye
  ], h = (e == null ? void 0 : e.value.split(".").filter(($) => $ !== "")) ?? [
    Te
  ];
  return it(t, u, h);
}, it = (t, e, u) => t.map((h) => {
  const $ = e == null ? void 0 : e.reduce((g, _) => g && g[_], h), Y = u == null ? void 0 : u.reduce((g, _) => g && g[_], h);
  return {
    label: $,
    value: Y
  };
}), Ye = {
  convert: it,
  prepare: ge
}, Ee = (t, e) => (t.order || 0) - (e.order || 0), He = {
  asc: Ee
}, _e = (t, e) => {
  if (!ot(t, e) || !e.parameter)
    return e;
  const u = {
    ...t
  };
  u.parameter = u.parameter || {};
  for (const [h, $] of Object.entries(e.parameter))
    if (!(h in u.parameter))
      u.parameter = {
        ...u.parameter,
        [h]: $
      };
    else if (u.parameter) {
      const Y = u.parameter[h];
      if (Y && typeof Y == "string") {
        const g = Y.split(",");
        g.push(`${$}`), u.parameter[h] = g.join(",");
      }
    }
  return u;
}, ot = (t, e) => !t || !e || t.url !== e.url || t.method !== e.method || t.namespace !== e.namespace || JSON.stringify(t.parameter) !== JSON.stringify(e.parameter), Se = (t, e) => {
  var u, h;
  return q.isObject(t) && ((h = (u = e == null ? void 0 : e.split(".")) == null ? void 0 : u.filter(($) => $ !== "")) == null || h.forEach(($) => {
    t && (t = t[$]);
  })), t;
}, Ie = {
  diff: ot,
  extract: Se,
  merge: _e
}, Oe = /^(\d{0,2}):?(\d{0,2}):?(\d{0,2})\s?([AaPp][Mm])?$/, we = /^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])/, ve = (t) => {
  t = t == null ? void 0 : t.replace(we, "").trim();
  const e = t == null ? void 0 : t.match(Oe);
  return [
    e && e[1] ? e[1] : void 0,
    e && e[2] ? e[2] : void 0,
    e && e[3] ? e[3] : void 0,
    e && e[4] ? e[4] : void 0
  ];
};
function at(t) {
  const e = ve(t);
  if (q.isUndefined(e[0]))
    return null;
  let u = e[0] ? Number(e[0]) : 0;
  e[3] && e[3].toLowerCase() === "pm" && (u = 12 + u);
  const h = e[1] ? Number(e[1]) : 0, $ = e[2] ? Number(e[2]) : 0;
  return k().hour(u).minute(h).second($).toDate();
}
function Le(t, e = "HH:mm") {
  let u = k();
  if (t instanceof Date && (u = k(t)), typeof t == "string" && t !== "now") {
    const h = at(t);
    if (q.isNull(h))
      return null;
    u = k(h);
  }
  return u.format(e);
}
const Ae = {
  format: Le,
  from: at
}, je = {
  currency: oe,
  date: ue,
  datetime: de,
  decimal: le,
  time: Ae
}, Re = {
  select: Ye
};
export {
  be as accent,
  Rt as color,
  xe as constants,
  je as formatter,
  Re as helper,
  Ce as math,
  Ne as router,
  He as sort,
  Ie as source,
  q as validator
};
